import axios from 'axios'
import updatePriority from 'gatsby-theme-centurylink/src/utils/updatePriority'

export default async function zipLogic(zipCode, isSpanishURL) {
  try {
    const datasetUrl = `https://dm.clear.link/api/datasets/centurylink-internet/find?search[ZIP_CD]=${zipCode}`
    const submissionData = await axios.get(datasetUrl, {
      headers: {
        'X-Api-Key': '8b1370a310dc4af0b370071303f359a5',
      },
    })

    const zipData = submissionData?.data?.dataset?.data
      ? submissionData?.data?.dataset?.data[0]
      : null

    // Add a condition to check if zipData is null or undefined
    if (!zipData) {
      // If zipData is null or undefined, treat it as out of area
      return {
        typeOfService: 'OOA',
        centurylinkService: false,
        getQFiberPackages: [],
        getQFiberDisclaimer: null,
      }
    }

    let typeOfService
    const isQuantum = zipData.QF_Marketable === 'Yes'
    const isCenturylink =
      zipData.CTL_Available === 'Yes' && zipData.QF_Marketable === 'No'
    const isOOA =
      !zipData ||
      (zipData.QF_Marketable === 'No' && zipData.CTL_Available === 'No')

    if (isQuantum) {
      typeOfService = 'QF'
    }

    if (isCenturylink) {
      typeOfService = 'CTL'
    }

    if (isOOA) {
      typeOfService = 'OOA'
    }

    // Creating a key value map for speeds available
    const speedMap = {
      '940 Mbps': 0.9,
      '1 Gbps': 1,
      '2 Gbps': 2,
      '3 Gbps': 3,
      '8 Gbps': 8,
    }

    // Get the highest speed value from DSM
    const highestSpeed = zipData.QF_Highest_Speed

    const maxSpeed = speedMap[highestSpeed] || 0

    // Set speed based on value coming back from pkg
    const getSpeedFromPackage = (pkg) => {
      if (pkg.includes('500')) return 0.5
      if (pkg.includes('940')) return 0.9
      if (pkg.includes('1gig')) return 1
      if (pkg.includes('2gig')) return 2
      if (pkg.includes('3gig')) return 3
      if (pkg.includes('8gig')) return 8
      return 0
    }

    // Filter an array of packages based on a maximum speed limit.
    // Returns only those packages whose speed is less than or equal to the provided maxSpeedLimit.
    const filterPackagesBySpeed = (packages, maxSpeedLimit) => {
      return packages.filter((pkg) => {
        const speed = getSpeedFromPackage(pkg)
        // Exclude '940' package if maxSpeedLimit is 1 or higher
        if (maxSpeedLimit >= 1 && pkg.includes('940')) {
          return false
        }
        return speed <= maxSpeedLimit
      })
    }

    if (zipData && zipData?.QF_Marketable === 'Yes') {
      const { data } = await axios.get(
        'https://brandy.clear.link/data/brand/QF'
      )

      let packagesToShow = []
      switch (zipData.GQF_Product_Group) {
        case 'Normal':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-500-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt2${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Standard':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-500-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt2${isSpanishURL ? '-es' : ''}`,
              // THESE STAY UNTIL THEY ARE RE-IMPLEMENT IN A COUPLE MONTHS
              // THE ABOVE PACKAGES MATCH THE "NORMAL" SET SHOWN ABOVE TEMPORARILY
              // `qf-fiber-500-mkt1${spanish ? '-es' : ''}`,
              // `qf-fiber-940-mkt6${spanish ? '-es' : ''}`,
              // `qf-fiber-1gig-mkt6${spanish ? '-es' : ''}`,
              // `qf-fiber-2gig-mkt1${spanish ? '-es' : ''}`,
              // `qf-fiber-3gig-mkt1${spanish ? '-es' : ''}`,
              // `qf-fiber-8gig-mkt2${spanish ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Denver':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-200-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-500-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt1${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Las Vegas':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-200-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-500-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt1${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Minneapolis':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-200-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-500-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt4${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt4${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt3${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Omaha':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-200-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-500-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt4${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt4${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt2${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Orlando':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-200-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-500-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt1${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Phoenix':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-200-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-500-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt5${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt5${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt1${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Portland':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-200-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-500-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt5${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt5${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt1${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Salt Lake City':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-200-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-500-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt2${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Seattle':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-500-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt1${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'Cape Coral':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-200-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-500-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt3${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt3${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        case 'AO4':
          packagesToShow = filterPackagesBySpeed(
            [
              `qf-fiber-500-mkt1${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-940-mkt7${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-1gig-mkt7${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-2gig-mkt4${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-3gig-mkt2${isSpanishURL ? '-es' : ''}`,
              `qf-fiber-8gig-mkt2${isSpanishURL ? '-es' : ''}`,
            ],
            maxSpeed
          )
          break
        default:
          packagesToShow = []
          break
      }

      const packageSectionData = []

      packagesToShow.forEach((currentPackage) => {
        /* eslint-disable */
        const attributes = data.data[`${currentPackage}`].attributes
        const name = data.data[`${currentPackage}`].name

        const allBulletKeyReferences = []
        const bulletKeysArray = Object.keys(attributes)

        bulletKeysArray.map(
          (key) =>
            key.includes('bullets-attributes') &&
            allBulletKeyReferences.push(key)
        )

        const bullets = Object.keys(attributes)
          .filter(
            (attrKey) =>
              attrKey.startsWith('bullets-') && !attrKey.endsWith('-disclaimer')
          )
          .map((bulletKey) => {
            const bulletObj = {
              text: attributes[bulletKey],
            }
            const bulletIdentifier = bulletKey.replace('bullets-', '')
            const disclaimerText =
              attributes[`bullets-${bulletIdentifier}-disclaimer`]
            const disclaimerSymbol =
              attributes[`bullets-${bulletIdentifier}-disclaimer-symbol`]
            if (disclaimerText) {
              bulletObj.disclaimer = {
                text: disclaimerText,
                symbol: disclaimerSymbol,
              }
            }
            return bulletObj
          })

        const packageData = {
          label: '',
          brandy: {
            name,
            bullets,
            price: {
              before: `${attributes['pricing-before'] || ''}`,
              amount: `${attributes['pricing-amount']}`,
              duration: `${attributes['pricing-duration']}`,
              disclaimer: {
                text: `${attributes['pricing-disclaimer']}`,
              },
            },
          },
        }

        packageSectionData.push(packageData)
      })

      updatePriority(626)

      return {
        typeOfService,
        city: zipData.City,
        state: zipData.State,
        centurylinkService: zipData.CTL_Available === 'Yes' || false,
        getQFiberPackages: packageSectionData,
        getQFiberDisclaimer: {
          text: data.brand_data.QF.attributes[
            `disclaimer-fasterthanaverage${isSpanishURL ? '-es' : ''}`
          ],
          symbol:
            data.brand_data.QF.attributes[
              `disclaimer-fasterthanaverage-symbol${isSpanishURL ? '-es' : ''}`
            ],
        },
      }
    } else if (zipData && zipData.CTL_Available === 'Yes') {
      updatePriority(isSpanishURL ? 631 : 626)
      return {
        centurylinkService: true,
        typeOfService,
        getQFiberPackages: [],
        getQFiberDisclaimer: null,
      }
    } else {
      updatePriority(isSpanishURL ? 630 : 625)

      return {
        centurylinkService: false,
        typeOfService,
        getQFiberPackages: [],
        getQFiberDisclaimer: null,
      }
    }
  } catch (err) {
    // error occurred
    return null
  }
}
